module.exports = __webpack_public_path__ + "img/mantencion.7126cd4d.svg";